export const PageSizeOptions: number[] = [10, 25, 50, 100];
